// extracted by mini-css-extract-plugin
export default {"card_shadow":"Login_card_shadow__Y8ude"};